import { Component, inject, OnInit } from '@angular/core';
import { faCheck, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-yes-no-cancel',
  standalone: false,
  styles: ``,
  templateUrl: './yes-no-cancel.component.html',
})
export class YesNoCancelComponent implements OnInit {

  fasTimes = faTimes;
  fasCheck = faCheck;

  prompt: string = `Are you sure?`;
  yesBtnText?: string = `Yes`;
  noBtnText?: string = `No`;
  cancelBtnText?: string = `Cancel`;

  private modal = inject(NgbActiveModal);

  ngOnInit(): void {
  }

  confirmModal(yesNo: boolean): void {
    this.modal.close(yesNo);
  }

  dismissModal(): void {
    this.modal.dismiss();
  }


}
